export interface MPOrderOption {
   btnLabel: string
   btnKey: MPOrderOptionKeyEnum
}

export enum MPOrderOptionKeyEnum {
   TITLE = 'title',
   LAST_MODIFIED = 'last_modified_date',
}
